var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"branchDetail_btn other_btn_4",attrs:{"to":_vm.$route.query.branchId
        ? {
            name: 'updateRejectedRecord',
            query: {
              branchId: _vm.$route.query.branchId,
              companyId: _vm.$route.query.companyId,
              data: JSON.stringify(_vm.cleanedData),
            },
          }
        : {
            name: 'updateRejectedRecord',
            query: {
              branchId: _vm.$route.query.branchId,
              companyId: _vm.$route.query.companyId,
              data: JSON.stringify(_vm.cleanedData),
            },
          }}},[_vm._v(_vm._s(_vm.$t("text.actionButtons.update")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }